import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { HwhMainMenuComponent } from './hwh-main-menu.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule
  ],
  declarations: [HwhMainMenuComponent],
  exports: [HwhMainMenuComponent],
})
export class HwhMainMenuModule { }
